import React from 'react';
import { Copy } from 'lucide-react';
import { spreadPaste } from '../lib/recovery.js';

/** Read-only 12-word grid (register step 2, settings reveal). */
export function PhraseGrid({ words, columns = 3, onCopy }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {onCopy && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}><span className="km-kicker">Recovery phrase · 12 words</span><button type="button" className="km-btn-ghost" style={{ padding: 0 }} onClick={onCopy}><Copy size={13} />Copy</button></div>}
      <div style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, minmax(0,1fr))`, gap: 6 }}>
        {words.map((w, i) => <span key={i} className="km-mono" style={{ display: 'flex', gap: 8, alignItems: 'baseline', padding: '7px 10px', borderRadius: 7, background: 'var(--km-bg)', fontSize: 13, fontWeight: 500 }}><span className="km-faint" style={{ fontSize: 11, width: 16 }}>{String(i + 1).padStart(2, '0')}</span>{w}</span>)}
      </div>
    </div>
  );
}

/** Editable 12-input grid; paste a whole phrase into any cell. */
export function PhraseInput({ words, onChange, badIndex = -1 }) {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0,1fr))', gap: 6 }}>
      {words.map((v, i) => (
        <label key={i} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '0 8px 0 10px', borderRadius: 7, background: 'var(--km-bg)', border: `1px solid ${badIndex === i ? 'var(--km-bad)' : 'var(--km-line)'}` }}>
          <span className="km-mono km-faint" style={{ fontSize: 11, width: 16 }}>{String(i + 1).padStart(2, '0')}</span>
          <input className="km-mono" value={v} autoCapitalize="off" autoCorrect="off" spellCheck={false} onChange={(e) => onChange(spreadPaste(words, i, e.target.value))} style={{ width: '100%', minWidth: 0, background: 'transparent', border: 'none', outline: 'none', fontSize: 13, fontWeight: 500, padding: '8px 0' }} />
        </label>
      ))}
    </div>
  );
}
